import { SortTypes } from "util/table-view/TableTypes";
import { actionTypes } from "./CueSheetLinkActions";
import { pagingTotalRelation, defaultResultsPerPage } from "redux/Types";

const initialState = {
  items: [],
  totalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  cueSheet: {},
  selectedItems: [],
  loading: false,
  loadingMore: false,
  posting: { busy: false, message: "", errors: null },
  editing: null,
  session:{},
  linkCf:null,
  noMore: true,
  sessionId:"",
  query: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
    csId:""
  },
  errors: null,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        loadingMore: false,
        errors: null,
        selectedItems: [],
        items: [],
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: null,
        items: action.payload,
        totalItems: action.total,
        totalRelation: action.totalRelation,
        selectedItem: action.payload[0] || {},
        selectedItems: [],
        noMore: false,
      };
    case actionTypes.SET_CUESHEET:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: null,
        cueSheet: action.payload,
      };
    case actionTypes.SET_SESSION:
      return {
        ...state,
        sessionId: action.payload.sessionId,
        session: action.payload,
      };
    case actionTypes.SET_LINK_CF:
      return {
        ...state,
        linkCf: action.payload,
      };
    case actionTypes.RESET_LINK_CF:
      return {
        ...state,
        linkCf: null,
      };
    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: action.payload,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
        noMore: true,
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };
    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };

    case actionTypes.EDIT_ITEM:
      return {
        ...state,
        editing: action.payload,
      };

    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message:"",
          errors: null,
        },
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: action.message? action.message : "",
          errors: action.payload,
        },
      };
    case actionTypes.POST_LINK_ERROR:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.message? action.message : "",
          // errors: action.payload,
        },
      };

    default:
      return state;
  }
}
